import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import GMCContext from "./GMCContext";
import App from "./App";
import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";


const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GMCContext>
        <App />
      </GMCContext>
    </QueryClientProvider>
  </React.StrictMode>
);
reportWebVitals();
